module.exports = __webpack_public_path__ + "img/carregar.b96ab978.webp";